import { z } from 'zod';

export const Timeframe = z.enum([
  'last30Days',
  'last7Days',
  'previousMonth',
  'previousWeek',
  'thisMonthFrom1st',
  'thisWeekFromMonday',
  'today',
  'yesterday',
  'previousMonthFirstCycle',
  'previousMonthSecondCycle',
  'thisMonthFirstCycle',
  'thisMonthSecondCycle',
  'custom',
]);

export type Timeframe = z.infer<typeof Timeframe>;

export const DEFAULT_TIMEFRAME: Timeframe = 'today';

export const MAXIMUM_SELECTED_DATERANGE = 31;
export const MAXIMUM_LOOKBACK_DAYS = 90;
